import styled from 'styled-components';
import { baseColors, body1, textColors, WebLink } from 'ui/theme';
import { InfoFill } from 'ui/icons/status/InfoFill';
import { OpenNewWindow16 } from 'ui/icons/action/OpenNewWindow16';
import { pxToRem } from 'utils/convert';

/**
  If in future it is determined that this HelpFooter is intended for use
  predominantly in index pages, it should be moved under /ui/indexPages.
  As of now, no decision from design.
*/

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  height: ${pxToRem(152)};
  justify-content: center;
`;

const Content = styled.div`
  align-items: center;
  display: flex;
`;

const Text = styled.span`
  ${body1}
  color: ${textColors.textSecondary};
`;

const InfoIcon = styled(InfoFill)`
  margin-right: ${pxToRem(6)};
`;

const Link = styled(WebLink)`
  align-items: center;
  display: flex;
`;

const OpenIcon = styled(OpenNewWindow16)`
  margin-left: ${pxToRem(6)};
`;

type Props = {
  text: string;
  href: string;
};

export const HelpFooter = ({ href, text }: Props) => (
  <Wrapper>
    <Content>
      <InfoIcon color={baseColors.cyan100}></InfoIcon>
      <Text>Learn more about&nbsp;</Text>
      <Link href={href}>
        {text}
        <OpenIcon isColorInherited={true}></OpenIcon>
      </Link>
    </Content>
  </Wrapper>
);
